import { Alert, Button, Form, Input } from 'antd';
import { Lock, Mail } from 'lucide-react';

interface PasswordFormValues {
  email: string;
  password: string;
}

interface LoginPasswordFormProps {
  title: string;
  /** Says what follows a password, or, where no code can be sent, why the password is the only way in. */
  lead: string;
  /** The email typed on the start step, so it needn't be typed twice. */
  initialEmail?: string;
  error: string | null;
  submitting: boolean;
  onSubmit: (values: PasswordFormValues) => void;
}

export function LoginPasswordForm({ title, lead, initialEmail, error, submitting, onSubmit }: LoginPasswordFormProps) {
  return (
    <>
      <h1 className="text-2xl font-semibold tracking-tight text-fg">{title}</h1>
      <p className="mt-1.5 mb-8 text-sm text-muted">{lead}</p>
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      <Form<PasswordFormValues>
        layout="vertical"
        size="large"
        requiredMark={false}
        initialValues={{ email: initialEmail }}
        onFinish={onSubmit}
        disabled={submitting}
      >
        <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
          <Input prefix={<Mail className="size-4 text-muted" />} autoComplete="email" placeholder="you@company.com" />
        </Form.Item>
        <Form.Item name="password" label="Password" rules={[{ required: true }]}>
          <Input.Password prefix={<Lock className="size-4 text-muted" />} autoComplete="current-password" autoFocus={Boolean(initialEmail)} />
        </Form.Item>
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" htmlType="submit" block loading={submitting}>
            Sign in
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
